import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'estructura-organizacional/unidades-responsables/';

/**
 * GET unidades-responsables
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getUnidadesResponsables = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
